<template>
    <!-- main section -->
 <section class="hero is-flex main">
   <div class="bg-img">
     <div class="img2 icon"><img src="../assets/images/book.png" alt=""></div>
     <div class="img3 icon"><img src="../assets/images/rocket.png" alt=""></div>
     <div class="img4 icon"><img src="../assets/images/cloud3.png" alt=""></div>
     <div class="img5 icon"><img src="../assets/images/award.png" alt=""></div>
     <div class="img6 icon"><img src="../assets/images/apple.png" alt=""></div>
   </div>
   <div class="title">Dashboard</div>
   <div class="container flex ">
        <div v-if="getUserType == 'SA'" @click="$router.push({ name: 'manage-account'})" class="box">
            <div class="icon"><img src="../assets/images/user.svg" alt=""></div>
            <div class="box-title">Manage Accounts</div>
        </div>
        <div @click="$router.push({ name: 'classrooms'})" class="box">
           <div class="icon"><img src="../assets/images/user.svg" alt=""></div>
           <div class="box-title">Manage Classrooms</div>
       </div>
   </div>
 </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

// var timetable = new Timetable();
export default {
 name: "SchoolHome",
 components: {
 },
 data() {
   return {
    //  user_cards: [
    //  ],
   };
 },
 methods: {
   ...mapActions(["loadKids"]),
 },
 computed: {
   ...mapGetters([
      "getUserType"
     ]),
  //  showCards() {
  //    if (this.getUserType == "T") return this.fetchMenu;
  //    else if (this.getUserType == "A") return this.fetchAdministratorMenu;

  //    //If nothing is true return nothing
  //    return [];
  //  },
//    userCards() {
//      const colors_length = this.fetchColors.length;
//      let kid_cards = [];
//      for (let kid_index in this.fetchKids) {
//        let kid = this.fetchKids[kid_index];
//        kid_cards.push({
//          name: kid.name,
//          title_size: "is-2",
//          styles: {
//            card_color: this.fetchColors[colors_length - 1 - kid_index],
//          },
//          router_params: {
//            kid_id: kid._id,
//          },
//        });
//      }
//      return [...this.user_cards, ...kid_cards];
//    },
 },
 created() {
   
 },
};
</script>
<style scoped>

.flex {
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
}
.container {
 position: relative;
}

.bg-img {
 display: flex;
 position: absolute;
 top: 0;
 left: 0;
 bottom: 0;
 right: 0;
 width: 100%;
 height: 100%;
 z-index: -1;
}
.bg-img div {
 display: flex;
 position: absolute;
 width: auto;
}

.title {
 font-size: 3vw;
 margin: 0 !important;
}

img {
 width: 100%;
 height: 100%;
 object-fit: fill;
}

.button {
 flex-direction: row;
 padding: 1vw 1.25vw;
 width: 100%;
 background: #8919e7;
 border-radius: 1vw;
 color: #fff;
 gap: 1vw;
 cursor: pointer;
 position: relative;
 text-transform: capitalize;
}
.button.outline {
 border: 0.063rem solid #8919e7;
 background: #fff;
 color: #000;
}
.link {
 cursor: pointer;
}

.main {
 align-items: center;
 margin: 0vw 0vw;
 position: relative;
 gap: 2.4vw;
}
/* responsive page*/

/* tablet */
@media screen and (max-width: 1023px) {
 .title{
   font-size: 3.5vw !important;
 }
}

/* Mobiles */
@media screen and (max-width: 767px) {
 .title {
   font-size: 4vw !important;
 }
}

@media screen and (max-width: 467px){
 .title{
   font-size: 5vw !important;
 }
}
/* background image */
.bg-img .icon {
 max-width: 7vw;
 height: auto;
}
.bg-img .img1 {
 bottom: 0;
 left: 0;
 right: 0;
}
.bg-img .img2 {
 top: 50%;
 right: 13.5%;
}
.bg-img .img3 {
 top: 66.33%;
 left: 21.7%;
}
.bg-img .img4 {
 top: 36.33%;
 right: 7.625%;
}
.bg-img .img5 {
 top: 54.44%;
 left: 7.4375%;
}
.bg-img .img6 {
 top: 51.67%;
 left: 18.6%;
}
.logo-container {
 margin-left: 60px;
}
/* main section */
.main {
 background: url(../assets/images/cloud2.png);
 background-repeat: no-repeat;
 background-size: contain;
 background-position: bottom;
 padding: 6.76vw 4.4vw 18vw;
 margin: 0;
 min-height: 90vh;
}
.main .page-title {
 font-weight: 600;
 font-size: 36px;
 line-height: 45px;
}
.main .container .box {
 display: flex;
 align-items: center;
 gap: 2vw;
 width: 100%;
 max-width: 34.26vw;
 background: #ffffff;
 border: 1px solid #dddddd;
 box-shadow: 0px 20px 40px rgb(0 0 0 / 13%);
 border-radius: 1.1vw;
 padding: 2vw;
 margin: 0;
 cursor:pointer;
}
.main .container .icon {
 width: 2vw;
 height: auto;
}
.main .container .box-title {
 font-weight: 600;
 font-size: 2vw;
 color: #202020;
 text-transform: capitalize;
}

.main .container .box:hover {
 border-color: #8919e7;
}
.main .container {
 width: 100%;
 gap: 3.73vw;
 justify-content: flex-start;
}

/* responsive page*/

/* tablet */
@media screen and (max-width: 1024px) {
 .main .container .box {
   box-shadow: 0px 15px 20px rgb(0 0 0 / 13%);
 }
}

/* Mobiles */
@media screen and (max-width: 767px) {
 .main .container .box {
   padding: 3.5vw;
 }
}
</style>